import { useEffect } from 'react';
import AuthMessageDialog from './AuthMessageDialog';
import useAuthMessageDialog from '../../hooks/useAuthMessageDialog';
import { bindMessageDialogHandlers } from '../../services/messageDialogService';

export default function MessageDialogProvider({ children }) {
  const { dialog, closeDialog, showError, showRegisterDialog } = useAuthMessageDialog();

  useEffect(() => {
    bindMessageDialogHandlers({
      showError: showError,
      showRegister: showRegisterDialog,
    });

    return () => {
      bindMessageDialogHandlers({
        showError: null,
        showRegister: null,
      });
    };
  }, [showError, showRegisterDialog]);

  return (
    <>
      {children}
      <AuthMessageDialog
        open={dialog.open}
        variant={dialog.variant}
        title={dialog.title}
        message={dialog.message}
        onClose={closeDialog}
      />
    </>
  );
}
